import React from 'react'

import { Color } from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import {
  NumPersonsToBoxDescriptors,
  NumPersonsToBoxDescriptorsItem,
  NumPersonsToBoxDescriptorsList,
} from 'routes/BoxPrices/boxPricesModels'
import {
  getNumPersonsToBoxDescriptors,
  getMenuBoxPricesRecieve,
} from 'routes/BoxPrices/boxPricesSelectors'

import { AccordionTableRowContainer, AccordionTableRow } from './index'

const isRowIndexEven = (index: number) => index % 2 === 0

const sortBoxPricesDescendingByNumberOfRecipes = (boxPrices: NumPersonsToBoxDescriptorsList) =>
  [...boxPrices].sort(
    (entry1: NumPersonsToBoxDescriptorsItem, entry2: NumPersonsToBoxDescriptorsItem) =>
      entry2.num_portions - entry1.num_portions,
  )

export const AccordionTableBody = ({ boxSize }: { boxSize: number }) => {
  const numPersonsToBoxDescriptors = useSelector(
    getNumPersonsToBoxDescriptors,
  ) as NumPersonsToBoxDescriptors
  const boxPrices = sortBoxPricesDescendingByNumberOfRecipes(numPersonsToBoxDescriptors[boxSize])
  const isLoading = Boolean(useSelector(getMenuBoxPricesRecieve))

  return (
    <>
      {boxPrices.map((boxPrice, index) => (
        <AccordionTableRowContainer
          key={`table-row-${boxPrice.num_portions}-portions`}
          bgColor={isRowIndexEven(index) ? Color.NeutralGrey_50 : Color.White}
        >
          <AccordionTableRow boxPrice={boxPrice} isLoading={isLoading} isBestValue={index === 0} />
        </AccordionTableRowContainer>
      ))}
    </>
  )
}
